import requestApi from "./requestApi";
import { API_CONSTANT_MAP } from "./paths";

export const getAllServicos = async () => {
  return requestApi.get(API_CONSTANT_MAP.servico);
};

export const getServicoById = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.servico}/${id}`);
};

export const saveServico = async (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.servico, payload);
}; 